// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import WebauthnController from "./webauthn_controller"
application.register("webauthn", WebauthnController)

import ShellController from "./shell_controller"
application.register("shell", ShellController)

import SlidePanelController from "./slide_panel_controller"
application.register("slide-panel", SlidePanelController)

import RepeatableInputController from "./repeatable_input_controller"
application.register("repeatable-input", RepeatableInputController)

import HotkeysController from "./hotkeys_controller"
application.register("hotkeys", HotkeysController)

import ApprovalQueueController from "./approval_queue_controller"
application.register("approval-queue", ApprovalQueueController)

import ThemeEditorController from "./theme_editor_controller"
application.register("theme-editor", ThemeEditorController)

import ImageCropperController from "./image_cropper_controller"
application.register("image-cropper", ImageCropperController)

import ListingSearchController from "./listing_search_controller"
application.register("listing-search", ListingSearchController)

import KindFieldsController from "./kind_fields_controller"
application.register("kind-fields", KindFieldsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)
